import { PayRange } from './offer/type'

export function formatContractType(contractType: string | null): string {
  if (!contractType) {
    return 'Non précisé'
  }
  switch (true) {
    case /cdi/i.test(contractType):
      return 'CDI'

    case /stage/i.test(contractType):
    case /internship/i.test(contractType):
      return 'Stage'

    case /cdd/i.test(contractType):
      return 'CDD'

    case /alternance/i.test(contractType):
      return 'Alternance'

    case /freelance/i.test(contractType):
      return 'Indépendant'

    default:
      return 'Non précisé'
  }
}

export function formatStartDate(startDate: string | null): string {
  if (startDate && typeof startDate === 'string') {
    if (startDate === 'Dès que possible' || startDate.startsWith('Début')) {
      return startDate
    }
    return `Début le ${new Date(startDate).toLocaleDateString('fr-FR')}`
  }
  return 'Dès que possible'
}

export function formatSalary({ min, max }: PayRange) {
  if (min && max && min !== max && min !== 0 && max !== 0) {
    return `${min.toString()} à ${max.toString()} K€`
  }
  if (min && min !== 0) {
    return `À partir de ${min.toString()} K€`
  }
  return null
}

export function formatRangeForGoogleJobs(
  range: number | null | undefined,
): number | null {
  if (range && range !== 0) {
    return range * 1000
  }
  return null
}

export function formatExperienceLevel(level: number | string): string {
  switch (level) {
    case 0:
      return 'Non précisé'
    case 1:
    case 'Lamajunior (- 1 an)':
      return "- 1 an d'expérience"
    case 2:
    case 'Lamaffirmé (1 à 2 ans)':
      return "1 à 2 ans d'expérience"
    case 3:
    case 'Lamasenior (2 à 5 ans)':
      return "2 à 5 ans d'expérience"
    case 4:
    case 'Lamexpert (+ 5 ans)':
      return "+ 5 ans d'expérience"
    default:
      return 'Non précisé'
  }
}

export function getLastUpdateDate(dates: string[]): Date | null {
  if (!dates || dates.length === 0) {
    return null
  }
  return new Date(Math.max(...dates.map((d) => new Date(d).getTime())))
}

export function formatPublishedDate(publishedDate: Date | string): string {
  if (publishedDate && publishedDate instanceof Date) {
    return `Offre publiée le ${publishedDate.toLocaleDateString('fr-FR')}`
  }
  if (publishedDate && typeof publishedDate === 'string') {
    return `Offre publiée le ${new Date(publishedDate).toLocaleDateString('fr-FR')}`
  }
  return ''
}
